import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import type { ThunkDispatch } from '@reduxjs/toolkit';
import type { AnyAction } from '@reduxjs/toolkit';
import './second-step-modal.style.scss';
import ready_platform from '../../../../../public/assets/svg/ready_platform.svg'; // Replace with actual ready image path
import { useTranslation } from 'react-i18next';
type AppDispatch = ThunkDispatch<any, any, AnyAction>;

interface SecondStepModalProps {
  show: boolean;
  onClose: () => void;
  onStartTour?: () => void; // invoked only when user clicks Start Tour
}

const SecondStepModal: React.FC<SecondStepModalProps> = ({ show, onClose, onStartTour }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (show) {
      setIsLoading(true);
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [show]);

  const handleStartTour = () => {
    // Close modal first, then start tour
    onClose();
    
    // Start the tour after modal closes
    if (onStartTour) {
      onStartTour();
    }
  };

  if (!show) return null;

  return (
    <div className="second-step-modal-overlay">
      <div className="second-step-modal-content Hold-modal">
        {/* Close Icon */}
        <button 
          type="button"
          className="Hold-modal-close-btn" 
          onClick={onClose} 
          aria-label="Close"
        >
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M24 8L8 24" stroke="#1A1A1A" strokeWidth="2" strokeLinecap="round"/><path d="M8 8L24 24" stroke="#1A1A1A" strokeWidth="2" strokeLinecap="round"/></svg>
        </button>

        {/* Main Icon */}
        <div className="Hold-modal-main-icon">
          <img
            src={isLoading ? '/assets/gif/Invozio_gif_loading.gif' : ready_platform}
            alt={isLoading ? 'Loading' : 'Ready'}
          />
        </div>

        <p className="Hold-modal-subtitle">
          {isLoading
            ? t('HOLD_ON_CREATING_PERSONALISED_EXPERIENCE')
            : t('PLATFORM_READY_MESSAGE')}
        </p>

        <div className="welcome-popup-footer_2">
          <div className="progress-dots">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className={`dot active`}></div>
          </div>

          <button
            className="welcome-next-btn"
            disabled={isLoading}
            onClick={!isLoading ? handleStartTour : undefined}
          >
            {isLoading ? (
              <span>
                {t('LOADING')}...
              </span>
            ) : (
              t('START_TOUR')
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SecondStepModal;
